export const adminLedgerAccountsApi = {

    getAll () {
        return axios.get(`/api/admin/ledger_account`)
    },

}
